document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);


        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });


        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }
});



jQuery(document).ready(function ($) {
    $('#kakmista-contact-form').on('submit', function (e) {
        e.preventDefault();
        $('#kakmista-popup-thank-you').fadeIn(300);

        setTimeout(function () {
            $('#kakmista-popup-thank-you').fadeOut(300);
        }, 3000);

        $('#kakmista-contact-form')[0].reset();
    });

    $('#kakmista-subscribe').on('submit', function (e) {
        e.preventDefault();
        $('#kakmista-subscribe-thank-you').fadeIn(300);

        setTimeout(function () {
            $('#kakmista-subscribe-thank-you').fadeOut(300);
        }, 3000);

        $('#kakmista-subscribe')[0].reset();
    });
});